var map = {
	"./WFM2.png": "./src/assets/img/WFM2.png",
	"./XB.png": "./src/assets/img/XB.png",
	"./XPM.png": "./src/assets/img/XPM.png",
	"./bi.png": "./src/assets/img/bi.png",
	"./blank-avatar.png": "./src/assets/img/blank-avatar.png",
	"./brand/argon-react-white.png": "./src/assets/img/brand/argon-react-white.png",
	"./brand/argon-react.png": "./src/assets/img/brand/argon-react.png",
	"./brand/blue.png": "./src/assets/img/brand/blue.png",
	"./brand/favicon.png": "./src/assets/img/brand/favicon.png",
	"./brand/logo-placeholder.png": "./src/assets/img/brand/logo-placeholder.png",
	"./brand/white.png": "./src/assets/img/brand/white.png",
	"./cards/amex.png": "./src/assets/img/cards/amex.png",
	"./cards/diners.png": "./src/assets/img/cards/diners.png",
	"./cards/discover.png": "./src/assets/img/cards/discover.png",
	"./cards/jcb.png": "./src/assets/img/cards/jcb.png",
	"./cards/mastercard.png": "./src/assets/img/cards/mastercard.png",
	"./cards/unionpay.png": "./src/assets/img/cards/unionpay.png",
	"./cards/unknown.png": "./src/assets/img/cards/unknown.png",
	"./cards/visa.png": "./src/assets/img/cards/visa.png",
	"./check.png": "./src/assets/img/check.png",
	"./clients/blank-avatar.png": "./src/assets/img/clients/blank-avatar.png",
	"./clients/exportpdf.png": "./src/assets/img/clients/exportpdf.png",
	"./clients/oldman.png": "./src/assets/img/clients/oldman.png",
	"./clients/samchocshop.png": "./src/assets/img/clients/samchocshop.png",
	"./courses/bootcamp.png": "./src/assets/img/courses/bootcamp.png",
	"./courses/combined-3rd-party.png": "./src/assets/img/courses/combined-3rd-party.png",
	"./courses/instructional.png": "./src/assets/img/courses/instructional.png",
	"./courses/myob.png": "./src/assets/img/courses/myob.png",
	"./courses/quickbooks.png": "./src/assets/img/courses/quickbooks.png",
	"./courses/xero.png": "./src/assets/img/courses/xero.png",
	"./etani-ai.png": "./src/assets/img/etani-ai.png",
	"./etani-full-logo.png": "./src/assets/img/etani-full-logo.png",
	"./etani-logo-cms.png": "./src/assets/img/etani-logo-cms.png",
	"./etani-logo.png": "./src/assets/img/etani-logo.png",
	"./etanilogo.png": "./src/assets/img/etanilogo.png",
	"./google-coming-soon.png": "./src/assets/img/google-coming-soon.png",
	"./icons/cards/bitcoin.png": "./src/assets/img/icons/cards/bitcoin.png",
	"./icons/cards/mastercard.png": "./src/assets/img/icons/cards/mastercard.png",
	"./icons/cards/paypal.png": "./src/assets/img/icons/cards/paypal.png",
	"./icons/cards/visa.png": "./src/assets/img/icons/cards/visa.png",
	"./icons/flags/DE.png": "./src/assets/img/icons/flags/DE.png",
	"./icons/flags/GB.png": "./src/assets/img/icons/flags/GB.png",
	"./icons/flags/US.png": "./src/assets/img/icons/flags/US.png",
	"./pbi-logo.png": "./src/assets/img/pbi-logo.png",
	"./services/aroflo.png": "./src/assets/img/services/aroflo.png",
	"./services/dear.png": "./src/assets/img/services/dear.png",
	"./services/kounta.png": "./src/assets/img/services/kounta.png",
	"./services/myob.png": "./src/assets/img/services/myob.png",
	"./services/powerbi.png": "./src/assets/img/services/powerbi.png",
	"./services/quickbooks.png": "./src/assets/img/services/quickbooks.png",
	"./services/unleashed.png": "./src/assets/img/services/unleashed.png",
	"./services/vend.png": "./src/assets/img/services/vend.png",
	"./services/workflow.png": "./src/assets/img/services/workflow.png",
	"./services/xero.png": "./src/assets/img/services/xero.png",
	"./services/xeropayroll.png": "./src/assets/img/services/xeropayroll.png",
	"./services/xeroprojects.png": "./src/assets/img/services/xeroprojects.png",
	"./services/xpm.png": "./src/assets/img/services/xpm.png",
	"./theme/accountingfirmplan.png": "./src/assets/img/theme/accountingfirmplan.png",
	"./theme/businessplan.png": "./src/assets/img/theme/businessplan.png",
	"./theme/extendedfirmplan.png": "./src/assets/img/theme/extendedfirmplan.png",
	"./theme/landing-1.png": "./src/assets/img/theme/landing-1.png",
	"./theme/landing-2.png": "./src/assets/img/theme/landing-2.png",
	"./theme/landing-3.png": "./src/assets/img/theme/landing-3.png",
	"./vcfo-logo-cms.png": "./src/assets/img/vcfo-logo-cms.png",
	"./vcfo-logo-white-cms.png": "./src/assets/img/vcfo-logo-white-cms.png",
	"./vcfo-logo.png": "./src/assets/img/vcfo-logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.png$";